import styled from 'styled-components';

export const HomeCaroMainImageWrap = styled.div(
  props => `
      width: 100%;
      display: flex;
      margin-bottom: ${props.theme.spacing.large};
    `,
);

export const HomeCaroBigImg = styled.img(
  props => `
    cursor: pointer;
    width: 59rem;
      height: 19rem;
      display: flex;
      border-radius: ${props.theme.misc.borderRadius.xxxlarge};
      object-fit: cover;
    `,
);



export const SliderArrow = styled.button(
  props => `
      width: 4rem;
      height: 4rem;
      display: flex;
      border-radius: 50%;
      background-color: white;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: absolute;
      box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.25);
      border:none;
      outline: 0;
      &.right {
        top: 50%;
        right: -1rem;
        transform: translateY(-50%);
      }
      &.left {
        top: 50%;
        left: -1rem;
        transform: translateY(-50%);
      }
    `,
);